// IE 2026 10 29 / ODOO-5800 (заказ Игоря: история изменений списка, ie-dm7 #114916)
// Объяснения по Alt / Show tooltips вкладки «History of changes» СПИСКА (components_core/AttrListHistory.vue + listHistory/Lh*.vue): ключи 'listHistory.<элемент>'.
// Формат записи — как у прочих областей (utils/uiHelp.js; образец — uiHelp/pmHistory.js). Тексты — английские литералы в t() (словари uk / ru — src/i18n/messages);
// полноту (каждый v-uiHelp компонентов имеет запись, все строки переведены) проверяет tests/unit/listHistoryIntegration.test.mjs.
import { t } from '@/i18n'

const READ_ONLY = () => t('Nothing — the history is only read.')

const listHistory = {
    // оболочка: состояния, шапка, строка «History settings», подвкладки
    'listHistory.off': () => ({
        title: t('History of changes is off'),
        what: t('The history of changes is switched off for this list by the administrator.'),
    }),
    'listHistory.error': () => ({
        title: t('History could not be read'),
        what: t('The server could not read the change journal of this list; the reason is shown in the message.'),
        click: t('Refresh — read the history again.'),
    }),
    'listHistory.empty': () => ({
        title: t('No changes'),
        what: t('Nothing changed in the records of this list within the chosen depth and filters.'),
        how: t('Choose a longer depth or clear the Kinds, Who and Fields filters.'),
    }),
    'listHistory.selection': () => ({
        title: t('Selection'),
        what: t('Which records of the list the history covers: the current filters, chips and access rights of the list apply.'),
    }),
    'listHistory.coverage': () => ({
        title: t('Journal coverage'),
        what: t('How completely the change journal covers this list: changes made before the journal was switched on, or by direct database updates, are not visible.'),
    }),
    'listHistory.refresh': () => ({
        title: t('Refresh'),
        what: t('Reads the history again with the current settings.'),
        affects: READ_ONLY(),
    }),
    'listHistory.settings': () => ({
        title: t('History settings'),
        what: t('What the history shows: depth, grouping, kinds of change, who changed, fields, signals. The badge on a button is the number of events.'),
        how: t('Click — only this value; Shift or ⌘ + click — add it to the chosen ones.'),
        stored: t('Not saved — the choice lives only in this tab.'),
    }),
    'listHistory.depth': () => ({
        title: t('Depth'),
        what: t('How far back the history is read: week, month, quarter, year or everything in the journal.'),
        click: t('Click — the history is read for this depth.'),
        now: t('«…» on a badge — this depth has not been counted yet.'),
    }),
    'listHistory.slice': () => ({
        title: t('Slice'),
        what: t('How the feed and the calendar group events: by day or by month.'),
    }),
    'listHistory.kinds': () => ({
        title: t('Kinds'),
        what: t('Kinds of change: created, changed, archived, deleted; for a data source also loads, recalculations and changes of its definition.'),
        how: t('Click — only this kind; Shift or ⌘ + click — add it.'),
    }),
    'listHistory.who': () => ({
        title: t('Who'),
        what: t('Who made the change: a person by hand, a load from 1C, the night regulation, an import, a calculation, a task or the system.'),
        how: t('Click — only this source; Shift or ⌘ + click — add it.'),
    }),
    'listHistory.fields': () => ({
        title: t('Fields'),
        what: t('Show only events in which these columns of the list changed; the badge is the number of changes of the field.'),
        how: t('Click — only this field; Shift or ⌘ + click — add it; «+N more» shows the other fields.'),
    }),
    'listHistory.signals': () => ({
        title: t('Signals'),
        what: t('Also show changes of computed signal columns; they are hidden by default because they change on every calculation.'),
    }),
    // IE 2026 10 29 / ODOO-5800 (ie-dm7 #115593: переключатель технических перезаписей)
    'listHistory.rewrites': () => ({
        title: t('Show technical rewrites'),
        what: t('The night regulation deletes and re-inserts rule records. By default each such pair is collapsed into one «changed» event and identical rewrites are hidden; the badge is the number of collapsed pairs.'),
        how: t('Turn on to show the technical delete and insert events of these rewrites as they are in the journal; the history is read again.'),
        stored: t('The switch is never saved — it lives only in this tab.'),
    }),
    'listHistory.subtabs': () => ({
        title: t('Views'),
        what: t('Feed — changes grouped into packets by time and author; By records — one row per record; Calendar — fields by days; for a data source also Sources and DS definition.'),
    }),
    'listHistory.summary': () => ({
        title: t('Summary'),
        what: t('Totals of the read history: records, events and packets, by kind of change and by people or tasks.'),
    }),
    // F6: частичный ответ, «Read more»; оверлей «Show in list»
    'listHistory.partial': () => ({
        title: t('Partly read'),
        what: t('The server stopped reading by its time budget: the listed blocks are incomplete and the badges are approximate (dashed).'),
        how: t('Read more — continue from where reading stopped; with automatic reading on, the tab continues by itself up to five times.'),
        setting: t('fe.ux.listHistoryAutoRead — automatic reading (on by default).'),
    }),
    'listHistory.readMore': () => ({
        title: t('Read more'),
        what: t('Continues reading the history from the point where the server stopped; already read parts come from the server cache.'),
        affects: READ_ONLY(),
        states: { busy: t('Unavailable: the previous request has not answered yet.') },
    }),
    'listHistory.overlayClear': () => ({
        title: t('Remove history filter'),
        what: t('Removes the filter «Show in list» put on the list by the history and re-reads the list.'),
        stored: t('The filter was never saved — it lives only in this tab.'),
    }),
    'listHistory.showInList': () => ({
        title: t('Show in list'),
        what: t('Filters the list to the rows touched by this event (a filter in memory) and opens the first tab.'),
        how: t('For object and subject pairs the filter goes by object only, so it may show more rows than were touched.'),
        stored: t('Not saved with the list; remove it with «Remove history filter».'),
    }),
    'listHistory.bindPage': () => ({
        title: t('Bind to visible page'),
        what: t('For a heavy data source: read the history only for the rows loaded on the visible page of the list.'),
        affects: READ_ONLY(),
    }),
    // лента
    'listHistory.feed': () => ({
        title: t('Feed'),
        what: t('Changes grouped into packets: one author or task, one kind of source, close in time.'),
    }),
    'listHistory.feedDay': () => ({
        title: t('Day'),
        what: t('Packets of this day (or month) with the number of events.'),
    }),
    'listHistory.feedPacket': () => ({
        title: t('Packet'),
        what: t('A group of changes made together: who, which task or load, how many records and events, which fields.'),
        click: t('Click — show the events of the packet; again — hide them.'),
    }),
    'listHistory.feedRecord': () => ({
        title: t('Record'),
        what: t('The changed record of the list.'),
        click: t('Click — open the record card.'),
    }),
    'listHistory.feedMore': () => ({
        title: t('More fields'),
        what: t('The record was created with more filled fields than are shown here.'),
    }),
    // «За записами»
    'listHistory.records.search': () => ({ title: t('Search'), what: t('Filters the table by the record title.') }),
    'listHistory.records.sort': () => ({ title: t('Sort'), what: t('Orders the records by the last change, by the number of events or by title.'), click: t('Click — sort by this column.') }),
    'listHistory.records.count': () => ({ title: t('Events'), what: t('How many changes of the record are in the read history.') }),
    'listHistory.records.chronology': () => ({ title: t('Chronology'), what: t('All changes of one record, newest first.'), click: t('Click — show the chronology of the record.') }),
    'listHistory.records.open': () => ({ title: t('Open record'), what: t('Opens the record card.') }),
    'listHistory.records.back': () => ({ title: t('Back'), what: t('Returns to the table of records.') }),
    // «Календар»
    'listHistory.calendar.axis': () => ({ title: t('Rows'), what: t('What the calendar rows are: fields of the list or who changed.') }),
    'listHistory.calendar.grid': () => ({ title: t('Calendar'), what: t('Number of changes per row and day; the darker the cell, the more changes.') }),
    'listHistory.calendar.legend': () => ({ title: t('Legend'), what: t('Shades of the cells from few to many changes.') }),
    'listHistory.calendar.allFields': () => ({ title: t('All fields'), what: t('Show rows for all fields of the list, not only the changed ones.'), affects: READ_ONLY() }),
    'listHistory.calendar.left': () => ({ title: t('Left the selection'), what: t('Also read the records that left the current selection within the depth.'), affects: READ_ONLY() }),
    'listHistory.calendar.leftBlock': () => ({ title: t('Left the selection'), what: t('Records that matched the selection earlier and no longer match it, with the change that took them out.') }),
    'listHistory.calendar.readMore': () => ({ title: t('Read more'), what: t('Continue reading the records that left the selection.'), affects: READ_ONLY() }),
    'listHistory.calendar.openRecord': () => ({ title: t('Open record'), what: t('Opens the record card.') }),
    // DS: источники и определение
    'listHistory.sources': () => ({
        title: t('Sources'),
        what: t('The tables the data source reads, with their change journals and how their keys are linked to the rows of the list.'),
    }),
    'listHistory.sourceJournal': () => ({ title: t('Journal'), what: t('Whether the source has a change journal: full, manual edits only, or none.') }),
    'listHistory.sourceLink': () => ({ title: t('Link to rows'), what: t('How the journal is linked to the rows of the list: by full keys, by keys without rows, or not linked.') }),
    'listHistory.sourcePackets': () => ({ title: t('Packets of the source'), what: t('Changes of this source grouped into packets.'), click: t('Click — show the events of the packet.') }),
    'listHistory.sourceEvents': () => ({ title: t('Events of the source'), what: t('Changed rows of the source with their keys.') }),
    'listHistory.definition': () => ({
        title: t('DS definition'),
        what: t('Changes of the data source definition: query, columns, mapping.'),
    }),
    'listHistory.definitionDiff': () => ({ title: t('Show comparison'), what: t('Shows the definition text before and after the change, line by line.'), affects: READ_ONLY() }),
}

export default listHistory
